import { makeAutoObservable } from "mobx";

import { ZMfNodeCommon } from "../ZMfNode";
import { createExprBool, ExprBoolCtx } from "./createExprBool";
import { MfNode, MfNodeBase } from "./MfNode";

export const createMfNodeBase = (meta: ZMfNodeCommon) =>
  makeAutoObservable({
    // --- disable
    privateDisabledSelf: false,
    privateSetDisabledSelf(value: boolean) {
      this.privateDisabledSelf = value;
    },
    privateDisabledOwner: false,
    privateSetDisabledOwner(value: boolean) {
      this.privateDisabledOwner = value;
    },
    get disabled(): boolean {
      return this.privateDisabledOwner || this.privateDisabledSelf;
    },
    setDisabled(value) {
      if (value && !this.privateDisabledSelf) {
        this.privateSetDisabledSelf(true);
        disableItems(this as MfNode);
      } else if (!value && this.privateDisabledSelf) {
        this.privateSetDisabledSelf(false);
        // разрешить подчинённые элемнты можно только если не запрещен кто-то из владельцев
        if (!this.privateDisabledOwner) {
          enableItems(this as MfNode);
        }
      }
    },

    // --- hide
    get hidden(): boolean {
      return this.privateHiddenOwner || this.privateHiddenSelf;
    },
    setHidden(value: boolean): void {
      if (value && !this.privateHiddenSelf) {
        this.privateSetHiddenSelf(true);
        hideItems(this as MfNode);
      } else if (!value && this.privateHiddenSelf) {
        this.privateSetHiddenSelf(false);
        // показать подчинённые элемнты можно только если не скрыт кто-то из владельцев
        if (!this.privateDisabledOwner) {
          showItems(this as MfNode);
        }
      }
    },
    privateHiddenSelf: false,
    privateSetHiddenSelf(value: boolean) {
      this.privateHiddenSelf = value;
    },
    privateHiddenOwner: false,
    privateSetHiddenOwner(value: boolean) {
      this.privateHiddenOwner = value;
    },

    disableIf: createExprBool(meta.disableIf),
    hideIf: createExprBool(meta.hideIf),
    recalc(ctx: ExprBoolCtx) {
      if (this.disableIf) {
        const value = this.disableIf(this as MfNode, ctx);
        this.setDisabled(value);
      }
      if (this.hideIf) {
        const value = this.hideIf(this as MfNode, ctx);
        if (value !== this.hidden) {
          this.setHidden(value);
          ctx.onVisibilityChange();
        }
      }
    },
  } satisfies MfNodeBase);

const enableItems = (node: MfNode) => {
  node.items?.forEach((item) => {
    item.privateSetDisabledOwner(false);
    if (!item.privateDisabledSelf) {
      enableItems(item);
    }
  });
};

const disableItems = (node: MfNode) => {
  // Если узел уже имеет запрещённого владельца, то все нижележащие и так должны быть запрещены
  if (!node.privateDisabledOwner) {
    node.items?.forEach((item) => {
      disableItems(item);
      item.privateSetDisabledOwner(true);
    });
  }
};

const showItems = (node: MfNode) => {
  node.items?.forEach((item) => {
    item.privateSetHiddenOwner(false);
    if (!item.privateDisabledSelf) {
      showItems(item);
    }
  });
};

const hideItems = (node: MfNode) => {
  // Если узел уже имеет скрытого владельца, то все нижележащие и так должны быть невидимы
  if (!node.privateHiddenOwner) {
    node.items?.forEach((item) => {
      hideItems(item);
      item.privateSetHiddenOwner(true);
    });
  }
};
